export const LT_FEATURE_FLAG_UPDATE = 'LT_FEATURE_FLAG_UPDATE';
export const LT_FEATURE_FLAG_UPDATE_AMPLITUDE =
  'LT_FEATURE_FLAG_UPDATE_AMPLITUDE';
